<template>
  <!-- Settings Drawer -->
  <a-drawer
    class="settings-drawer"
    :class="[rtl ? 'settings-drawer-rtl' : '']"
    :placement="rtl ? 'left' : 'right'"
    :closable="false"
    :visible="showSettingsDrawer"
    :width="360"
    @close="toggleSettingsDrawer(false)"
  >
    <h-button type="link" class="btn-close" @click="toggleSettingsDrawer(false)">
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9">
        <g transform="translate(0.75 0.75)">
          <path
            d="M7.5,0,0,7.5"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.5"
          />
          <path
            d="M0,0,7.5,7.5"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.5"
          />
        </g>
      </svg>
    </h-button>

    <div class="drawer-content">
      <h6>Configurator</h6>
      <p>See our dashboard options.</p>
      <hr />

      <div class="sidebar-color">
        <h6>Sidebar Color</h6>
        <div class="sidebar-color__row">
          <h-radio v-model="sidebarColorModel" @change="onSidebarColorChange">
            <a-radio-button value="primary" class="bg-primary" />
            <a-radio-button value="secondary" class="bg-secondary" />
            <a-radio-button value="success" class="bg-success" />
            <a-radio-button value="danger" class="bg-danger" />
            <a-radio-button value="warning" class="bg-warning" />
            <a-radio-button value="black" class="bg-dark" />
          </h-radio>
          <button type="button" class="btn-sidebar-default" @click="resetSidebarColor">
            {{ $t('config.defaultColor') }}
          </button>
        </div>
      </div>

      <div class="sidebar-color sidebar-text-color">
        <h6>{{ $t('config.sidebarTextColor') }}</h6>
        <div class="sidebar-color__row">
          <h-radio v-model="sidebarTextColorModel" @change="onSidebarTextColorChange">
            <a-radio-button value="primary" class="bg-primary" />
            <a-radio-button value="white" class="bg-white" />
            <a-radio-button value="secondary" class="bg-secondary" />
            <a-radio-button value="success" class="bg-success" />
            <a-radio-button value="danger" class="bg-danger" />
            <a-radio-button value="warning" class="bg-warning" />
            <a-radio-button value="black" class="bg-dark" />
          </h-radio>
          <button type="button" class="btn-sidebar-default" @click="resetSidebarTextColor">
            {{ $t('config.defaultColor') }}
          </button>
        </div>
      </div>

      <div class="sidebar-color sidebar-text-color">
        <h6>{{ $t('config.textSelectedColor') }}</h6>
        <div class="sidebar-color__row">
          <h-radio
            v-model="sidebarSelectedTextColorModel"
            @change="onSidebarSelectedTextColorChange"
          >
            <a-radio-button value="primary" class="bg-primary" />
            <a-radio-button value="white" class="bg-white" />
            <a-radio-button value="secondary" class="bg-secondary" />
            <a-radio-button value="success" class="bg-success" />
            <a-radio-button value="danger" class="bg-danger" />
            <a-radio-button value="warning" class="bg-warning" />
            <a-radio-button value="black" class="bg-dark" />
          </h-radio>
          <button type="button" class="btn-sidebar-default" @click="resetSidebarSelectedTextColor">
            {{ $t('config.defaultColor') }}
          </button>
        </div>
      </div>

      <div class="sidenav-type">
        <h6>{{ $t('config.sidenavType') }}</h6>
        <p>{{ $t('config.sidenavTypeHint') }}</p>
        <h-switch v-model="sidenavTypeModel" @change="onSidenavTypeChange" />
      </div>

      <div class="navbar-fixed">
        <h6>Navbar Fixed</h6>
        <h-switch v-model="navbarFixedModel" @change="toggleNavbar(navbarFixedModel)" />
      </div>

      <div class="navbar-fixed">
        <h6>{{ $t('config.darkTheme') }}</h6>
        <h-switch v-model="navbarDarkModel" @change="toggleDarkModel" />
      </div>

      <!-- <div class="download">
        <a
          class="btn-cta btn-cta--dark"
          href="https://www.creative-tim.com/product/muse-vue-ant-design-dashboard"
          target="_blank"
          rel="noopener noreferrer"
        >
          FREE DOWNLOAD
        </a>
        <a
          class="btn-cta btn-cta--primary"
          href="https://www.creative-tim.com/product/muse-vue-ant-design-dashboard-pro"
          target="_blank"
          rel="noopener noreferrer"
        >
          UPGRADE TO PRO
        </a>
        <a
          class="btn-cta btn-cta--ghost"
          href="https://demos.creative-tim.com/muse-vue-ant-design-dashboard/documentation"
          target="_blank"
          rel="noopener noreferrer"
        >
          VIEW DOCUMENTATION
        </a>
      </div>

      <div class="sharing">
        <h6>Thank you for sharing!</h6>
        <div class="share-links">
          <a
            class="btn-share"
            target="_blank"
            rel="noopener noreferrer"
            href="https://twitter.com/intent/tweet?url=https://www.creative-tim.com/product/muse-vue-ant-design-dashboard&text=Check%20Muse%20Vue%20Ant%20Design%20made%20by%20@CreativeTim%20#webdesign%20#dashboard%20#antdesign%20#vue%20https://www.creative-tim.com/product/muse-vue-ant-design-dashboard"
          >
            <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true">
              <path
                fill="currentColor"
                d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
              />
            </svg>
            TWEET
          </a>
          <a
            class="btn-share"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/sharer/sharer.php?u=https://www.creative-tim.com/product/muse-vue-ant-design-dashboard"
          >
            <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true">
              <path
                fill="currentColor"
                d="M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
              />
            </svg>
            SHARE
          </a>
        </div>
      </div> -->
    </div>
  </a-drawer>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch, toRefs } from 'vue'
import cookiesConFig from '@/utils/CookiesConfig'
import {
  SIDEBAR_COLOR,
  SIDEBAR_TEXT_COLOR,
  SIDEBAR_SELECTED_TEXT_COLOR,
  SIDENAV_TYPE,
  DARK_TYPE,
  NAVBAR_DARK_MODEL,
  NAVBAR_FIXED_MODEL,
} from '@/const/ConstCookies'

const DEFAULT_SIDEBAR_COLOR = 'primary'
const DEFAULT_SIDEBAR_TEXT_COLOR = 'primary'
const DEFAULT_SIDEBAR_SELECTED_TEXT_COLOR = 'white'
const DEFAULT_SIDENAV_TYPE = true

const emits = defineEmits([
  'darkModel',
  'toggleNavbarPosition',
  'updateSidenavType',
  'updateSidebarColor',
  'updateSidebarTextColor',
  'updateSidebarSelectedTextColor',
  'toggleSettingsDrawer',
])

interface Props {
  showSettingsDrawer: boolean
  sidebarColor: string
  sidebarTextColor: string
  sidebarSelectedTextColor: string
  sidenavType: boolean
  darkMode: boolean
  navbarFixed: boolean
  rtl: boolean
}

const props = withDefaults(defineProps<Props>(), {
  sidebarColor: DEFAULT_SIDEBAR_COLOR,
  sidebarTextColor: DEFAULT_SIDEBAR_TEXT_COLOR,
  sidebarSelectedTextColor: DEFAULT_SIDEBAR_SELECTED_TEXT_COLOR,
  sidenavType: DEFAULT_SIDENAV_TYPE,
  darkMode: false,
  navbarFixed: false,
  rtl: false,
})

const { sidebarColor, sidebarTextColor, sidebarSelectedTextColor, sidenavType, darkMode } =
  toRefs(props)

const sidebarColorModel = ref(DEFAULT_SIDEBAR_COLOR)
const sidebarTextColorModel = ref(DEFAULT_SIDEBAR_TEXT_COLOR)
const sidebarSelectedTextColorModel = ref(DEFAULT_SIDEBAR_SELECTED_TEXT_COLOR)
const sidenavTypeModel = ref(DEFAULT_SIDENAV_TYPE)
const navbarFixedModel = ref(false)
const navbarDarkModel = ref(false)

const applySidebarColor = (val: string) => {
  const color = val || DEFAULT_SIDEBAR_COLOR
  sidebarColorModel.value = color
  emits('updateSidebarColor', color)
}

const applySidebarTextColor = (val: string) => {
  const color = val || DEFAULT_SIDEBAR_TEXT_COLOR
  sidebarTextColorModel.value = color
  emits('updateSidebarTextColor', color)
}

const applySidebarSelectedTextColor = (val: string) => {
  const color = val || DEFAULT_SIDEBAR_SELECTED_TEXT_COLOR
  sidebarSelectedTextColorModel.value = color
  emits('updateSidebarSelectedTextColor', color)
}

const onSidebarColorChange = (e: any) => {
  const val = e?.target?.value ?? sidebarColorModel.value
  applySidebarColor(val)
}

const onSidebarTextColorChange = (e: any) => {
  const val = e?.target?.value ?? sidebarTextColorModel.value
  applySidebarTextColor(val)
}

const onSidebarSelectedTextColorChange = (e: any) => {
  const val = e?.target?.value ?? sidebarSelectedTextColorModel.value
  applySidebarSelectedTextColor(val)
}

const onSidenavTypeChange = (val: boolean | string) => {
  const enabled = val === true || val === 'true'
  sidenavTypeModel.value = enabled
  emits('updateSidenavType', enabled)
}

const resetSidebarColor = () => {
  applySidebarColor(DEFAULT_SIDEBAR_COLOR)
}

const resetSidebarTextColor = () => {
  applySidebarTextColor(DEFAULT_SIDEBAR_TEXT_COLOR)
}

const resetSidebarSelectedTextColor = () => {
  applySidebarSelectedTextColor(DEFAULT_SIDEBAR_SELECTED_TEXT_COLOR)
}

onMounted(() => {
  modelConfig()
})

watch(
  sidebarColor,
  (val) => {
    if (val) sidebarColorModel.value = val
  },
  { immediate: true }
)

watch(
  sidebarTextColor,
  (val) => {
    if (val) sidebarTextColorModel.value = val
  },
  { immediate: true }
)

watch(
  sidebarSelectedTextColor,
  (val) => {
    if (val) sidebarSelectedTextColorModel.value = val
  },
  { immediate: true }
)

watch(
  sidenavType,
  (val) => {
    sidenavTypeModel.value = !!val
  },
  { immediate: true }
)

watch(
  darkMode,
  (val) => {
    navbarDarkModel.value = !!val
  },
  { immediate: true }
)

const toggleDarkModel = (val?: boolean | string) => {
  const enabled =
    typeof val === 'boolean' ? val : val === 'true' ? true : !!navbarDarkModel.value
  navbarDarkModel.value = enabled
  cookiesConFig.setCokies(NAVBAR_DARK_MODEL, enabled)
  cookiesConFig.setCokies(DARK_TYPE, enabled ? 'dark-mode' : '')
  emits('darkModel', enabled ? 'dark-mode' : '')
}

const toggleNavbar = (val: any) => {
  cookiesConFig.setCokies(NAVBAR_FIXED_MODEL, val)
  emits('toggleNavbarPosition', val)
}

const toggleSettingsDrawer = (val: any) => {
  emits('toggleSettingsDrawer', val)
}

const readSidenavType = () => {
  const raw = cookiesConFig.getCokies(SIDENAV_TYPE)
  if (raw === '' || raw === null || raw === undefined) return DEFAULT_SIDENAV_TYPE
  return raw === 'true' || raw === true
}

const readDarkMode = () => {
  const darkType = cookiesConFig.getCokies(DARK_TYPE)
  if (darkType === 'dark-mode') return true
  return cookiesConFig.getCokiesBoolean(NAVBAR_DARK_MODEL)
}

const modelConfig = () => {
  const savedColor = cookiesConFig.getCokies(SIDEBAR_COLOR)
  const savedTextColor = cookiesConFig.getCokies(SIDEBAR_TEXT_COLOR)
  const savedSelectedTextColor = cookiesConFig.getCokies(SIDEBAR_SELECTED_TEXT_COLOR)
  sidebarColorModel.value = savedColor || props.sidebarColor || DEFAULT_SIDEBAR_COLOR
  sidebarTextColorModel.value =
    savedTextColor || props.sidebarTextColor || DEFAULT_SIDEBAR_TEXT_COLOR
  sidebarSelectedTextColorModel.value =
    savedSelectedTextColor ||
    props.sidebarSelectedTextColor ||
    DEFAULT_SIDEBAR_SELECTED_TEXT_COLOR
  sidenavTypeModel.value =
    props.sidenavType !== undefined ? !!props.sidenavType : readSidenavType()
  navbarFixedModel.value = cookiesConFig.getCokiesBoolean(NAVBAR_FIXED_MODEL)
  navbarDarkModel.value = props.darkMode || readDarkMode()
}
</script>

<style lang="scss">
/* Drawer teleports to body — use global class, force readable sans font */
.settings-drawer {
  .ant-drawer-body,
  .drawer-content,
  .drawer-content h6,
  .drawer-content p,
  .drawer-content button,
  .drawer-content a,
  .drawer-content .ant-btn,
  .drawer-content .ant-switch {
    font-family: "Open Sans", Helvetica, Arial, system-ui, -apple-system, "Segoe UI", sans-serif !important;
  }

  .drawer-content {
    h6 {
      font-weight: 600;
      color: #141414;
      letter-spacing: 0;
    }

    > h6 {
      font-size: 20px;
    }

    p {
      color: #8c8c8c;
      font-size: 14px;
      line-height: 1.5;
    }
  }

  .sidebar-color {
    h6 {
      margin-bottom: 10px;
    }

    &__row {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;
    }
  }

  .btn-sidebar-default {
    min-height: 32px;
    padding: 0 12px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    background: #fff;
    color: #141414;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    cursor: pointer;
    transition: border-color 0.2s ease, color 0.2s ease;
  }

  .btn-sidebar-default:hover {
    border-color: #b19663;
    color: #b19663;
  }

  .sidebar-text-color {
    margin-top: 16px;
  }

  .sidebar-text-color .bg-white {
    background: #fff !important;
    border: 1px solid #d9d9d9 !important;
  }

  .sidenav-type {
    margin-top: 16px;
  }

  .download {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 24px;
  }

  .btn-cta {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 44px;
    padding: 0 16px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    text-decoration: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: opacity 0.2s ease, transform 0.2s ease;

    &:hover {
      opacity: 0.92;
      color: inherit;
    }

    &--dark {
      background: #141414;
      color: #fff;
    }

    &--primary {
      background: #b19663;
      color: #fff;
    }

    &--ghost {
      background: #fff;
      color: #141414;
      border: 1px solid #e5e7eb;
    }
  }

  .btn-close {
    color: #141414;
  }

  .sharing {
    margin-top: 24px;
    text-align: center;

    h6 {
      margin-bottom: 12px;
      font-size: 16px;
      font-weight: 700;
    }
  }

  .share-links {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .btn-share {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 40px;
    padding: 0 18px;
    border-radius: 8px;
    background: #141414;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    text-decoration: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

    svg {
      flex-shrink: 0;
    }

    &:hover {
      color: #fff;
      opacity: 0.9;
    }
  }
}

/* Dark theme for Configurator drawer */
.dark-mode .settings-drawer .ant-drawer-content,
.dark-mode .settings-drawer .ant-drawer-wrapper-body,
.dark-mode .settings-drawer .ant-drawer-body {
  background: #151c2c !important;
  color: rgba(255, 255, 255, 0.88) !important;
}

.dark-mode .settings-drawer .drawer-content h6,
.dark-mode .settings-drawer .drawer-content > h6,
.dark-mode .settings-drawer .navbar-fixed h6,
.dark-mode .settings-drawer .sidenav-type h6,
.dark-mode .settings-drawer .sidebar-color h6,
.dark-mode .settings-drawer .sharing h6 {
  color: rgba(255, 255, 255, 0.92) !important;
}

.dark-mode .settings-drawer .drawer-content p,
.dark-mode .settings-drawer .sidenav-type p {
  color: rgba(255, 255, 255, 0.55) !important;
}

.dark-mode .settings-drawer .drawer-content > hr {
  background-color: rgba(255, 255, 255, 0.12) !important;
}

.dark-mode .settings-drawer .btn-close {
  color: rgba(255, 255, 255, 0.85) !important;
}

.dark-mode .settings-drawer .btn-sidebar-default {
  background: #1b2436 !important;
  border-color: rgba(255, 255, 255, 0.18) !important;
  color: rgba(255, 255, 255, 0.88) !important;
}

.dark-mode .settings-drawer .btn-sidebar-default:hover {
  border-color: #b19663 !important;
  color: #b19663 !important;
}

.dark-mode .settings-drawer .btn-cta--ghost {
  background: #1b2436 !important;
  color: rgba(255, 255, 255, 0.9) !important;
  border-color: rgba(255, 255, 255, 0.16) !important;
}

.dark-mode .settings-drawer .sidebar-text-color .bg-white {
  background: #fff !important;
  border: 1px solid rgba(255, 255, 255, 0.35) !important;
}

.dark-mode .settings-drawer .ant-radio-button-wrapper {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.dark-mode .settings-drawer .ant-switch {
  background: rgba(255, 255, 255, 0.25);
}
</style>
